import { CACHE_DURATION, generateHash } from '@shared/cache/cache.browser';

const SELECTOR_KEY_PREFIX = 'reptile-scroll-selector-';

function selectorStorageKey(): string {
    return SELECTOR_KEY_PREFIX + generateHash(location.href.replace(location.hash, ''));
}

export function findTopVisibleTile(): HTMLElement | null {
    const tiles = document.querySelectorAll<HTMLElement>('.reptile-tile-item');
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    for (const tile of Array.from(tiles)) {
        const rect = tile.getBoundingClientRect();
        if (rect.height <= 0) continue;

        const startsInViewport = rect.top >= 0 && rect.top <= viewportHeight;
        const endsInViewport = rect.bottom >= 0 && rect.bottom <= viewportHeight;
        const occupiesFullScreen = rect.top < 0 && rect.bottom > viewportHeight;

        if (!startsInViewport && !endsInViewport && !occupiesFullScreen) continue;

        const moreThan40PercentVisible = rect.top + rect.height > rect.height * 0.4;
        if (moreThan40PercentVisible) return tile;
    }

    return null;
}

function createSelector(tile: HTMLElement): string | null {
    const { variationId, localListPosition } = tile.dataset;
    if (!variationId || !localListPosition) return null;
    return `[data-variation-id="${variationId}"][data-local-list-position="${localListPosition}"]`;
}

function persistSelector(selector: string): void {
    try {
        sessionStorage.setItem(selectorStorageKey(), JSON.stringify({ selector, savedAt: Date.now() }));
    } catch {
        /*                         */
    }
}

export function saveScrollSelector(): void {
    const tile = findTopVisibleTile();
    if (!tile) return;
    const selector = createSelector(tile);
    if (!selector) return;
    persistSelector(selector);
}

/**
 *
 *
 *
 */
export function saveScrollSelectorForPosition(localListPosition: number): void {
    const tile = document.querySelector<HTMLElement>(
        `.reptile-tile-item[data-local-list-position="${localListPosition}"]`,
    );
    if (!tile) return;
    const selector = createSelector(tile);
    if (!selector) return;
    persistSelector(selector);
}

/**
 *
 *
 *
 *
 *
 *
 */
export async function restoreBySelector(): Promise<void> {
    let entry: { selector: string; savedAt: number } | null = null;
    try {
        const raw = sessionStorage.getItem(selectorStorageKey());
        if (raw) entry = JSON.parse(raw);
    } catch {
        /*                                           */
    }

    try {
        sessionStorage.removeItem(selectorStorageKey());
    } catch {
        /*                         */
    }

    if (!entry) return;

    const ageMinutes = (Date.now() - entry.savedAt) / 1000 / 60;
    if (ageMinutes > CACHE_DURATION) return;

    document.querySelector(entry.selector)?.scrollIntoView();
}
